import React from 'react'
import '../styles/LiquidBlockTop.css'

const LiquidBlockTop = ({children, className}) => {
  return (
    <div className='LiqBlockTopBGBG'>
        <div className={`LiqBlockTop ${className || ''}`}>
            <div className='LiqBlockTopBG'>
                {children}
            </div>
        </div>
    </div>
  )
}

export default LiquidBlockTop